export default __webpack_public_path__ + "static/media/suburban-areas.212105f2.svg";